import Repository from "./Repository";

const PAYMENT_RESOURCE = "/refund-fan-payment";
export default {
  singleRefund(payload) {
    return Repository.post(`${PAYMENT_RESOURCE}`, payload);
  },
};
